// Lightweight wrapper for Remix Icon usage.
// Usage:
//   <Icon name="calendar-line" />                  → default 16px
//   <Icon name="close-line" size={20} />           → custom size in px
//   <Icon name="arrow-right-s-line" class="text-primary" />  → arbitrary class
//   <Icon name="search-line" style={{ color: 'red' }} />     → arbitrary style
//
// All Remix Icon names available at https://remixicon.com (without the 'ri-' prefix).
export default function Icon(props) {
  // props:
  //   name:  string     - Remix Icon class name without the 'ri-' prefix (e.g. 'calendar-line')
  //   size:  number     - icon size in px (default 16)
  //   class: string     - additional class(es) merged with 'ri-<name>'
  //   style: object|string - additional inline style merged with font-size

  const size = () => props.size ?? 16
  const cls = () => `ri-${props.name} ${props.class || ''}`.trim()

  // Merge style: support either object or string
  const styleVal = () => {
    const base = { 'font-size': `${size()}px`, 'line-height': 1, 'vertical-align': 'middle' }
    if (props.style == null) return base
    if (typeof props.style === 'string') {
      // String style: leave as-is, prepend base
      return { ...base }   // caller is responsible if conflict
    }
    return { ...base, ...props.style }
  }

  return <i class={cls()} style={styleVal()} aria-hidden="true" />
}
